<template>
  <a v-if="backUrl" :href="backUrl" @click.prevent="goBack">
    <slot></slot>
  </a>
  <router-link v-else :to="to">
    <slot></slot>
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

defineProps({
  to: { type: Object, required: true }
});
const emit = defineEmits(['click']);

const router = useRouter();

const backUrl = computed(() => history?.state?.back);

function goBack(event) {
  router.back();
  emit('click', event);
}
</script>
